"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagCardCheckbox = void 0;
const input_checkbox_1 = require("../../components/input/input.checkbox");
const theme_1 = require("../../components/theme");
const mithril_1 = require("../../mithril");
const page_state_1 = require("../../state/page.state");
const tag_icon_1 = require("../tag.icon/tag.icon");
const tag_card_checkbox_style_1 = require("./tag.card.checkbox.style");
(0, theme_1.addStyles)(tag_card_checkbox_style_1.Style);
exports.TagCardCheckbox = {
    view(state, selectedState, tag, tagSummary, color) {
        const hasSelections = page_state_1.CurrentState.Tag.tagSize > 0;
        const className = `${tag_card_checkbox_style_1.CSS.container} ${hasSelections ? tag_card_checkbox_style_1.CSS.hasSelections : ''}`;
        return (0, mithril_1.m)('div', { className }, [
            hasSelections ? null : tag_icon_1.TagIcon.view(tag, tagSummary, color),
            input_checkbox_1.CheckBox.view(selectedState),
        ]);
    },
};
//# sourceMappingURL=tag.card.checkbox.js.map